export default __webpack_public_path__ + "static/media/desktop.8136358d.jpg";